<form [formGroup]="form">
  <div class="flex flex-col gap-4">
    <div class="w-full">
      <app-guide-card
        [fullWidth]="true"
        [valid]="form.get('name1')?.valid && form.get('validFrom')?.valid"
      >
        <div title>{{ 'meteringpoint.coredata.suggest.baseinformation' | translate }}</div>
        <app-input-group>
          <label appLabel>{{ 'meteringpoint.coredata.suggest.addresstype' | translate }}</label>
          <select appSelect [collection]="relationTypeOptions" formControlName="relationType">
          </select>
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'meteringpoint.coredata.suggest.contact1' | translate }}</label>
          <input
            type="text"
            formControlName="name1"
            appInput
            [placeholder]="'meteringpoint.coredata.suggest.contact1' | translate"
          />
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'meteringpoint.coredata.suggest.contact2' | translate }}</label>
          <input
            type="text"
            formControlName="name2"
            appInput
            [placeholder]="'meteringpoint.coredata.suggest.contact2' | translate"
          />
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'meteringpoint.coredata.suggest.phone' | translate }}</label>
          <input
            type="text"
            formControlName="phone"
            appInput
            [placeholder]="'meteringpoint.coredata.suggest.phone' | translate"
          />
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'meteringpoint.coredata.suggest.cellphone' | translate }}</label>
          <input
            type="text"
            formControlName="mobile"
            appInput
            [placeholder]="'meteringpoint.coredata.suggest.cellphone' | translate"
          />
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'meteringpoint.coredata.suggest.email' | translate }}</label>
          <input
            type="text"
            formControlName="email"
            appInput
            [placeholder]="'meteringpoint.coredata.suggest.email' | translate"
          />
        </app-input-group>
        <div class="border-b border-gray-200 mt-4 mb-2"></div>
        <app-input-group>
          <label appLabel>{{ 'common.date.validfrom' | translate }}</label>
          <input
            type="date"
            formControlName="validFrom"
            appInput
          />
        </app-input-group>
      </app-guide-card>
    </div>
  </div>
  <div>
    <app-meteringpoint-form-address
      [form]="form" formGroupName="locationAddress"
      overrideTitle="meteringpoint.coredata.suggest.address"
    ></app-meteringpoint-form-address>
  </div>
</form>
